import {
  FEATURE_CREDITS_API_KEYS,
  SUBSCRIPTIONS_API_KEYS,
} from "features/MySubscriptions/constants/MySubscriptions.constants";
import { useCreditDetails } from "features/MySubscriptions/utils/useCreditDetails";
import { RESOURCE_KEYS } from "utils/OrgPermissions";

export const useCheckAutomatedCommsCredits = () => {
  const {
    data: {
      [FEATURE_CREDITS_API_KEYS.total_credits]: totalWhatsappCredits,
      [FEATURE_CREDITS_API_KEYS.consumed_credits]: consumedWhatsappCredits,
    } = {},
  } = useCreditDetails({
    params: {
      [SUBSCRIPTIONS_API_KEYS.feature_key]:
        RESOURCE_KEYS.SUBSECTIONS.COMMUNICATIONS.AUTOMATED_WHATSAPP,
    },
  });

  const hasWhatsappCredits = consumedWhatsappCredits < totalWhatsappCredits;

  const {
    data: {
      [FEATURE_CREDITS_API_KEYS.total_credits]: totalEmailCredits,
      [FEATURE_CREDITS_API_KEYS.consumed_credits]: consumedEmailCredits,
    } = {},
  } = useCreditDetails({
    params: {
      [SUBSCRIPTIONS_API_KEYS.feature_key]:
        RESOURCE_KEYS.SUBSECTIONS.COMMUNICATIONS.AUTOMATED_EMAIL,
    },
  });

  const hasEmailCredits = consumedEmailCredits < totalEmailCredits;

  return {
    hasWhatsappCredits,
    hasEmailCredits,
  };
};
